module.exports = __webpack_public_path__ + "img/3076328-71-4.2a7cb298.png";